import request from '@/plugins/axios';
const controller = '/usermessage/';

// 获取用户接收的消息
export function getRecive(params) {
    return request.post(controller + 'recive', params)
}

// 读取用户消息的回复列表
export function getMessageReply(params) {
    return request.post(controller + 'get_message_reply', params)
}

// 回复消息
export function replyUserMessage(params) {
    return request.post(controller + 'reply_user_message', params)
}

// 写消息
export function submitMessage(params) {
    return request.post(controller + 'submit_message', params)
}

// 获取用户发送的消息
export function getSend(params) {
    return request.post(controller + 'send', params)
}

// 获取系统消息
export function getSystemMessage(params) {
    return request.post(controller + 'get_system_message', params)
}

// 设置系统消息已读数据
export function setSystemMessageRead(params) {
    return request.post(controller + 'set_system_message_read', params)
}